import { createFileRoute } from "@tanstack/react-router";
import ScrapDonationForm from "@project/donate/pages/scrap/index";

export const Route = createFileRoute("/donate/scrap")({
  head: () => ({ meta: [{ title: "Scrap Donation — Jivandhara" }] }),
  component: ScrapDonationForm,
});
